export interface Preloader {
  enabled?: boolean;
  pendingTasks?: number;
  position?: PreloaderPosition;
}

export enum PreloaderPosition {
  App = 'app',
  Primary = 'primary',
  Secondary = 'secondary'
}
